const DEFAULT_ISSUER = 'Blox';

/**
 * otpauth:// URI for TOTP apps (Google Authenticator, Authy, etc.).
 * @see https://github.com/google/google-authenticator/wiki/Key-Uri-Format
 */
export default function buildOtpAuthProvisioningUri(
  accountEmail: string,
  secretBase32: string,
  issuer = DEFAULT_ISSUER,
): string {
  const secret = secretBase32.replace(/\s+/g, '').toUpperCase();
  const label = encodeURIComponent(`${issuer}:${accountEmail}`);
  const issuerParameter = encodeURIComponent(issuer);
  return `otpauth://totp/${label}?secret=${encodeURIComponent(
    secret,
  )}&issuer=${issuerParameter}&algorithm=SHA1&digits=6&period=30`;
}
